/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import Container from '@material-ui/core/Container';

import FilterLanguage from '../survey2022/FilterLanguage/FilterLanguage';
// import TranslationTxt from '../survey2022/TranslationTxt/TranslationTxt';

import languagify from '../../utils/languagify';

import useStyles from './styles';

const Header = () => {
  const classes = useStyles();
  const location = useLocation();

  return (
    <div className={classes.headerSection}>
      <Container maxWidth="lg">
        <Box className={classes.header}>
          <Box className={classes.headerLogo}>
            <Typography variant="h1" className={classes.appTitle}>{location.pathname === '/2021' ? 'Canadian Newsroom Diversity Survey' : languagify('Canadian Newsroom Diversity Survey')}</Typography>
          </Box>
          <Box className={classes.linkQlik}>
            {/* <span className={classes.linkQlikText}>Analytics by</span> */}
            <a href="https://www.qlik.com/us/">
              <img src="assets/images/powered-byqlik.png" alt="Analytics by Qlik" className={classes.logoQlikAnalytics} />
            </a>
          </Box>
          {
            (location.pathname === '/2022' || location.pathname === '/comparison') && (
              <Box>
                <FilterLanguage />
              </Box>
            )
          }
        </Box>
        <Box className={classes.navigation}>
          <Link to="/2021" className={classes.link} style={{ color: `${location.pathname === '/2021' ? '#CF1F38' : '#959595'}` }}>{languagify('2021 Survey')}</Link>
          <Link to="/2022" className={classes.link} style={{ color: `${location.pathname === '/2022' ? '#CF1F38' : '#959595'}` }}>{languagify('2022 Survey')}</Link>
          <Link to="/comparison" className={classes.link} style={{ color: `${location.pathname === '/comparison' ? '#CF1F38' : '#959595'}` }}>{languagify('Data Comparison')}</Link>
        </Box>
      </Container>
    </div>
  );
};

export default Header;
